import { useUIColors } from '@/core/hooks';
import { useI18nContext } from '@/core/providers/I18nProvider';
import React from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';

export interface CheckboxProps {
    isSelected: boolean;
    isDisabled?: boolean;
    onPress?: () => void;
    size?: number;
}

export function Checkbox({
    isSelected,
    isDisabled = false,
    onPress,
    size = 19
}: CheckboxProps) {
    const colors = useUIColors();
    const { isRTL } = useI18nContext();

    return (
        <TouchableOpacity
            style={styles.checkbox}
            onPress={onPress}
            disabled={isDisabled}
            activeOpacity={isDisabled ? 1 : 0.7}
        >
            <View style={[
                styles.checkboxInner,
                {
                    width: size,
                    height: size,
                    backgroundColor: 'transparent', // Always transparent background
                    borderColor: isDisabled ? colors.outlineDisabled : colors.fontPrimary, // Black border as per Figma
                    opacity: isDisabled ? 0.5 : 1,
                }
            ]}>
                {isSelected && (
                    <View style={[
                        styles.checkmark,
                        {
                            borderColor: colors.fontPrimary,
                            transform: [{ rotate: '45deg' }]
                        }
                    ]} />
                )}
            </View>
        </TouchableOpacity>
    );
}

const styles = StyleSheet.create({
    checkbox: {
        // No padding needed - centered by container alignment
    },
    checkboxInner: {
        borderRadius: 4,
        borderWidth: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    checkmark: {
        width: 6,
        height: 10,
        borderRightWidth: 2,
        borderBottomWidth: 2,
    },
});

export default Checkbox;
